/**
 * 数据请求
 */
import request from '@/utils/request.js'

//用户注册
export const register = data => {
  return request({
    method: 'POST',
    url: '/reg',
    /* headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }, */
    dataType:'json',
    data 
  })
}
export const login = data => {
  return request({
    method: 'POST',
    url: '/login',
    dataType:'json',
    /* headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }, */
    data 
  })
}